// Dify API服务
import request from '../utils/ai_request';

// 上传文件
export async function uploadFile(file, user, agentId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('user', user);

    return request.post(`/dify/chat/${agentId}/files/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
}

// 消息反馈
export async function feedbackMessage(messageId, rating, content = '', user, agentId) {
  return request.post(`dify/chat/${agentId}/messages/${messageId}/feedbacks`, {
    rating, // 'like' | 'dislike' | null
    content,
    user,
  });
}

// 停止响应
export async function stopMessage(agentId,taskId,userId) {
  return request.post(`/dify/chat/${agentId}/chat-messages/${taskId}/${userId}/stop`);
}

// 获取会话历史消息
export async function getMessages(params) {
  return request.get(`/dify/chat/${params.agentId}/messages?userId=${params.user}&conversationId=${params.conversation_id}`)
}

// 获取对话变量
export async function getParameters(agentId) {
  return request.get(`dify/chat/${agentId}/parameters`)
}